/*
  ============================================================
  carrinho.js — Carrinho AJAX + gaveta (identidade RL)
  ============================================================

  O QUE FAZ:
  - Intercepta qualquer formulário de "adicionar ao carrinho"
    (form[action$="/cart/add"]) e envia pela Cart AJAX API da
    Shopify (/cart/add.js), pedindo junto a section "cart-drawer"
    já renderizada (Section Rendering API).
  - Atualiza a gaveta (#RlCartContent) e os contadores
    [data-cart-count] sem recarregar a página.
  - Botões de quantidade na gaveta usam /cart/change.js.
  - Animação do produto "voando" até o carrinho e pulso no
    contador (desligável em Configurações do tema).
  - Abre/fecha a gaveta com foco preso dentro dela (acessível),
    fecha com Esc e no fundo escurecido.

  OBSERVAÇÕES:
  - Sem JS, os formulários funcionam do jeito nativo (vão para
    /cart) e o botão do carrinho é um link normal para /cart.
  - Se o tipo de carrinho for "Página" nas configurações, a
    gaveta não existe e o script só atualiza o contador.
  - Não usa innerHTML com dados do visitante: o único HTML
    inserido é o que a própria loja devolve pela Section
    Rendering API.
*/
(function () {
  'use strict';

  var cfg = window.rlTheme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {} };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SECTION = 'cart-drawer';
  var lastFocus = null;
  var autoClose = null;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function drawer() { return document.getElementById('RlCartDrawer'); }
  function scrim() { return document.getElementById('RlCartScrim'); }

  /* ---------- Toast ---------- */
  var toastT;
  function toast(msg, isError) {
    var t = document.getElementById('RlToast'), tx = document.getElementById('RlToastText');
    if (!t || !tx) return;
    tx.textContent = msg;
    t.classList.toggle('is-err', !!isError);
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  window.rlToast = toast;

  /* ---------- Contador ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function pulse() {
    var b = $('[data-rl-cart-open]');
    var badge = $('.rl-badge[data-cart-count]');
    if (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    if (badge) { badge.classList.remove('is-pulse'); void badge.offsetWidth; badge.classList.add('is-pulse'); }
  }

  /* ---------- Gaveta ---------- */
  function trap(e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"])', d).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function open() {
    var d = drawer(); if (!d) return false;
    if (d.classList.contains('is-open')) return true;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (scrim()) scrim().classList.add('is-on');
    document.body.classList.add('rl-locked');
    $$('[data-rl-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.dispatchEvent(new CustomEvent('rl:cart-open'));
    setTimeout(function () { var c = $('[data-rl-cart-close].rl-icon-btn', d); if (c) c.focus({ preventScroll: true }); }, 350);
    return true;
  }
  function close() {
    var d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    clearTimeout(autoClose);
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (scrim()) scrim().classList.remove('is-on');
    document.body.classList.remove('rl-locked');
    $$('[data-rl-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.rlCart = { open: open, close: close, toast: toast };

  /* ---------- Troca o conteúdo da gaveta pelo HTML renderizado pela loja ---------- */
  function applySection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('RlCartContent');
    var cur = document.getElementById('RlCartContent');
    if (fresh && cur) {
      cur.replaceWith(fresh);
      setCount(fresh.getAttribute('data-count') || 0);
      syncPdpFrete(fresh);
    }
  }
  // A barra de frete grátis da página de produto é renderizada com o carrinho do carregamento;
  // copia o texto e o progresso da gaveta recém-renderizada pra ela não ficar parada em "Faltam R$ 1.200".
  function syncPdpFrete(fresh) {
    var src = fresh.querySelector('.rl-frete'); if (!src) return;
    var txt = src.querySelector('span'), bar = src.querySelector('.rl-bar i');
    $$('.rl-frete-pdp').forEach(function (p) {
      var span = p.querySelector('.rl-frete-pdp__row span'), i = p.querySelector('.rl-bar i');
      if (span && txt) span.innerHTML = txt.innerHTML.replace(/<svg[\s\S]*?<\/svg>/, '').trim();
      if (i && bar) i.style.width = bar.style.width;
    });
  }
  function refreshCount() {
    return fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------- Voo até o carrinho ---------- */
  function fly(fromEl) {
    var target = $('[data-rl-cart-open]');
    if (!cfg.fly || reduce || !fromEl || !target || !fromEl.animate) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var c = fromEl.cloneNode(true);
    c.classList.add('rl-fly'); c.removeAttribute('aria-label'); c.setAttribute('aria-hidden', 'true');
    c.style.cssText += ';left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;position:fixed;margin:0';
    document.body.appendChild(c);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    c.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 90) + 'px) scale(.55)', opacity: .95, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1)', opacity: .4 }
    ], { duration: 760, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = function () { c.remove(); };
  }

  /* ---------- Adicionar ao carrinho ---------- */
  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');

    var fd = new FormData(form);
    if (document.getElementById('RlCartContent')) {
      fd.append('sections', SECTION);
      fd.append('sections_url', window.location.pathname);
    }

    var src = form.closest('[data-rl-product]');
    var media = src ? src.querySelector('.rl-media') : document.querySelector('.product__media-item img');

    fetch(cfg.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || cfg.strings.error || 'Erro', true);
          return;
        }
        fly(media);
        pulse();
        if (res.data.sections && res.data.sections[SECTION]) applySection(res.data.sections[SECTION]);
        else refreshCount();

        if (button && button.classList.contains('rl-btn--line')) {
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 2200);
        }
        var name = form.getAttribute('data-product-title') || '';
        toast((name ? name + ' — ' : '') + (cfg.strings.added || 'Adicionado ao carrinho'));

        if (document.getElementById('RlCartDrawer')) {
          setTimeout(function () {
            open();
            clearTimeout(autoClose);
            autoClose = setTimeout(function () {
              var d = drawer();
              if (d && !d.matches(':hover') && !d.contains(document.activeElement)) close();
            }, 3600);
          }, reduce || !cfg.fly ? 0 : 700);
        }
      })
      .catch(function () {
        // Sem rede ou erro inesperado: envia do jeito tradicional.
        form.submit();
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  }

  /* ---------- Quantidade na gaveta ---------- */
  function changeLine(line, qty) {
    var d = drawer(); if (d) d.classList.add('is-loading');
    return fetch(cfg.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: [SECTION], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || cfg.strings.error, true); return; }
        if (res.data.sections && res.data.sections[SECTION]) applySection(res.data.sections[SECTION]);
        setCount(res.data.item_count);
      })
      .catch(function () { toast(cfg.strings.error || 'Erro', true); })
      .finally(function () { var d2 = drawer(); if (d2) d2.classList.remove('is-loading'); });
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('submit', handleSubmit);
  document.addEventListener('keydown', trap);
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-rl-cart-open]');
    if (openBtn && drawer()) { e.preventDefault(); open(); return; }
    var closeBtn = e.target.closest('[data-rl-cart-close]');
    if (closeBtn) { if (closeBtn.tagName === 'A' && closeBtn.getAttribute('href') !== '#') { close(); return; } e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-rl-qty]');
    if (q) { e.preventDefault(); changeLine(parseInt(q.getAttribute('data-line'), 10), Math.max(0, parseInt(q.getAttribute('data-qty'), 10))); }
  });
  // Volta pela navegação do navegador (bfcache): garante contador certo.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();
